import { defaultHover, Icon } from '@amelio/ui-library';
import { useEffect, useState } from 'react';

import { Locale } from '@/constants/Locale';
import i18n from '@/plugins/i18n';

interface AmelioHeaderProps {
    onToggleSidebar?: () => void;
}

export const AmelioHeader = ({ onToggleSidebar }: AmelioHeaderProps) => {
    const [locale, setLocale] = useState(i18n.language);

    useEffect(() => {
        const handleLanguageChange = () => {
            setLocale(i18n.language);
        };

        i18n.on('languageChanged', handleLanguageChange);
        return () => {
            i18n.off('languageChanged', handleLanguageChange);
        };
    }, [i18n]);

    return (
        <header
            className={
                'fixed z-99 flex h-16 w-full shrink-0 flex-row items-center justify-between border-b border-gray-200 bg-white'
            }
        >
            <button
                type={'button'}
                className={`ml-4 flex items-center justify-center rounded p-2 min-[1200px]:hidden ${defaultHover}`}
                onClick={onToggleSidebar}
                aria-label={'Toggle sidebar menu'}
                data-testid={'sidebar-toggle'}
            >
                <Icon
                    name={'essential-menu'}
                    size={'lg'}
                />
            </button>

            <div className={'hidden min-[1200px]:block'} />

            <button
                type={'button'}
                className={`pr-8 text-base ${defaultHover}`}
                onClick={() => i18n.changeLanguage(locale === Locale.EN ? Locale.FR : Locale.EN)}
            >
                {locale === Locale.EN ? 'FR' : 'EN'}
            </button>
        </header>
    );
};
